import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class StaticContentService {

  mangentoUrl = environment.apiURL
  constructor(private http: HttpClient) { }

  contactUs(data) {
    return this.http.post<any>(`${this.mangentoUrl}rest/V1/contactUs`, data);
  }
}
